import React from 'react';
import SchemeManagementSectionContainer from '../../SchemeManagementSectionContainer/SchemeManagementSectionContainer';
import { Col, Form, Row } from 'react-bootstrap';
import { FieldArray, getFormValues, reduxForm } from 'redux-form';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { CalculationClassField } from '../../CalculationClassField/CalculationClassField';
const SchemeGroupCalculationServiceArray = ({ values, fields, isViewOnly }) => {
  return (
    <>
      {fields.map((field, index) => (
        <>
          <h3>{`${values[index].name}`}</h3>
          <CalculationClassField
            label={'Winter Sports decline on each traveller'}
            name={`${field}.metadata.calculation_class`}
            isViewOnly={isViewOnly}
          />
        </>
      ))}
    </>
  );
};
const CalculationServiceSchemeGroupForm = ({ formValues, handleSubmit, isViewOnly }) => {
  return (
    <SchemeManagementSectionContainer
      title={''}
      subTitle={'Winter Sports Decline Handling'}
      isViewOnly={isViewOnly}
    >
      <Form horizontal onSubmit={handleSubmit}>
        <Row className="section-item">
          <Col sm={12}>
            <FieldArray
              name={'data.attributes.scheme_details'}
              values={formValues?.data?.attributes?.scheme_details ?? []}
              component={SchemeGroupCalculationServiceArray}
              isViewOnly={isViewOnly}
            />
          </Col>
        </Row>
      </Form>
    </SchemeManagementSectionContainer>
  );
};
export default compose(
  connect((state, props) => {
    return {
      formValues: getFormValues(props.formName)(state),
      destroyOnUnmount: false,
      enableReinitialize: true,
      form: props.formName,
    };
  }),
  reduxForm({}),
)(CalculationServiceSchemeGroupForm);
